import { FC, useRef, useContext } from 'react';
import {
  Box,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from '@chakra-ui/react';
import { AppScrollPortalContext } from 'app/components/AppScrollPortalContext';
import { ContextMenuProps as ContextMenuDataProps } from './types';

interface ContextMenuProps {
  contextMenuProps: ContextMenuDataProps;
}

export const ContextMenu: FC<ContextMenuProps> = ({ contextMenuProps }) => {
  const { options, position, setOptions } = contextMenuProps;
  const isOpen = (options || [])?.length > 0;
  const isHovered = useRef(false);
  const ref = useRef<HTMLButtonElement>(null);
  const outsideScrollContainerRef = useContext(AppScrollPortalContext);

  return (
    <Portal containerRef={outsideScrollContainerRef}>
      {isOpen && (
        <Box
          position="fixed"
          top={0}
          bottom={0}
          left={0}
          right={0}
          zIndex="modal"
          onContextMenu={(e) => {
            setOptions(null);
            e.preventDefault();
          }}
        />
      )}
      <Menu
        isOpen={isOpen}
        onClose={() => setOptions(null)}
        autoSelect={false}
        placement="bottom-end"
      >
        <MenuButton
          position="absolute"
          ref={ref}
          aria-hidden
          pointerEvents="none"
          w={1}
          h={1}
          left={position?.x || 0}
          top={position?.y || 0}
        />
        <MenuList
          onMouseEnter={() => {
            isHovered.current = true;
          }}
          onMouseLeave={() => {
            isHovered.current = false;
          }}
          onAnimationEnd={() => {
            if (isOpen && isHovered.current === false) {
              ref.current?.focus();
            }
          }}
        >
          {(options || []).map(({ title, value, ...rest }) => (
            <MenuItem key={value} {...rest} data-testid="kebab-menu-option">
              {title}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Portal>
  );
};
